export const environment = {
  production: false,
  apiUrl: 'https://app-dev.waitora.com',
  // Sentry (remontée des erreurs) : DSN PUBLIC du projet Sentry frontend (ce n'est pas un secret).
  // Vide = Sentry désactivé.
  sentryDsn: 'https://5bc4f42778c4e12228cfbc7d333a6bc1@o4512277351759872.ingest.de.sentry.io/4512277373517904',
  sentryEnvironment: 'dev',
};